// Keep the shared header's current jurisdiction in sync with the catalogue.
const regionSelector = document.querySelector('[data-region-selector]');
if (regionSelector) {
  const summary = regionSelector.querySelector('[data-region-summary]');
  const label = regionSelector.querySelector('[data-region-label]');
  const choices = [...regionSelector.querySelectorAll('[data-region-option]')];
  const valid = new Set(choices.map((choice) => choice.dataset.regionOption));
  const saveRegion = (region) => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `WP_AFTERMETOO_REGION=${encodeURIComponent(region)}; Max-Age=31536000; Path=/; SameSite=Lax${secure}`;
  };
  const showRegion = (region) => {
    const current = valid.has(region) ? region : 'on';
    const code = current.toUpperCase();
    label.textContent = code;
    summary.setAttribute('aria-label', `${summary.dataset.labelPrefix}: ${code}`);
    choices.forEach((choice) => {
      if (choice.dataset.regionOption === current) choice.setAttribute('aria-current', 'true');
      else choice.removeAttribute('aria-current');
    });
  };
  window.addEventListener('amt:region-change', (event) => {
    showRegion(event.detail?.region);
    regionSelector.open = false;
  });
  regionSelector.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-region-option]');
    if (!choice || !regionSelector.contains(choice)) return;
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const region = choice.dataset.regionOption;
    if (!valid.has(region)) return;
    // A regional article links straight to the sibling for that jurisdiction: remember
    // the choice and let the link navigate.
    if (document.querySelector('[data-guide-region-alternatives]')) { saveRegion(region); return; }
    event.preventDefault();
    saveRegion(region);
    // Everywhere else the choice is remembered in place (AFT-18): regional articles
    // and menu links resolve to this jurisdiction, and the library filters by it.
    // Visitors are no longer sent to the homepage to pick their province.
    window.dispatchEvent(new CustomEvent('amt:region-change', { detail: { region, source: 'header' } }));
  });
  document.addEventListener('pointerdown', (event) => {
    if (regionSelector.open && !regionSelector.contains(event.target)) regionSelector.open = false;
  });
  regionSelector.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    regionSelector.open = false;
    summary.focus();
  });
}
